import type { AirangeBuildInfo } from "./build-info";

type BuildInfoConsole = Pick<Console, "log">;

export function formatAirangeBuildInfo(buildInfo: AirangeBuildInfo): string {
  const { app, version, gitSha, builtAt } = buildInfo;
  return `[AIRange build] app=${app} version=${version} gitSha=${gitSha} builtAt=${builtAt}`;
}

export function logAirangeBuildInfo(
  buildInfo: AirangeBuildInfo,
  output: BuildInfoConsole = console,
): void {
  output.log(formatAirangeBuildInfo(buildInfo));
}
